"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTopEarnersQuery = exports.useGetTopBranchesQuery = exports.useGetTopRewardsQuery = exports.useGetActivityHeatmapQuery = exports.useGetTierDistributionQuery = exports.useGetGamificationAnalyticsQuery = exports.useGetChallengeAnalyticsQuery = exports.useGetRevenueAnalyticsQuery = exports.useGetUserEngagementQuery = exports.useGetDashboardOverviewQuery = exports.analyticsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var analyticsApi = (0, react_1.createApi)({
    reducerPath: "analyticsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_ACHIEVE_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    endpoints: function (builder) { return ({
        getDashboardOverview: builder.query({
            query: function (args) { return ({ url: "analytics/overview", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getUserEngagement: builder.query({
            query: function (args) { return ({ url: "analytics/engagement", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getRevenueAnalytics: builder.query({
            query: function (args) { return ({ url: "analytics/revenue", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getChallengeAnalytics: builder.query({
            query: function (args) { return ({ url: "analytics/challenges", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getGamificationAnalytics: builder.query({
            query: function (args) { return ({ url: "analytics/gamification", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getTierDistribution: builder.query({
            query: function (args) { return ({ url: "analytics/tier-distribution", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getActivityHeatmap: builder.query({
            query: function (args) { return ({ url: "analytics/activity-heatmap", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getTopRewards: builder.query({
            query: function (args) { return ({ url: "analytics/top-rewards", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getTopBranches: builder.query({
            query: function (args) { return ({ url: "analytics/top-branches", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
        getTopEarners: builder.query({
            query: function (args) { return ({ url: "analytics/top-earners", params: args }); },
            transformResponse: function (response) { return (0, base_query_1.unwrapEnvelope)(response); },
        }),
    }); },
});
exports.analyticsApi = analyticsApi;
var useGetDashboardOverviewQuery = analyticsApi.useGetDashboardOverviewQuery, useGetUserEngagementQuery = analyticsApi.useGetUserEngagementQuery, useGetRevenueAnalyticsQuery = analyticsApi.useGetRevenueAnalyticsQuery, useGetChallengeAnalyticsQuery = analyticsApi.useGetChallengeAnalyticsQuery, useGetGamificationAnalyticsQuery = analyticsApi.useGetGamificationAnalyticsQuery, useGetTierDistributionQuery = analyticsApi.useGetTierDistributionQuery, useGetActivityHeatmapQuery = analyticsApi.useGetActivityHeatmapQuery, useGetTopRewardsQuery = analyticsApi.useGetTopRewardsQuery, useGetTopBranchesQuery = analyticsApi.useGetTopBranchesQuery, useGetTopEarnersQuery = analyticsApi.useGetTopEarnersQuery;
exports.useGetDashboardOverviewQuery = useGetDashboardOverviewQuery;
exports.useGetUserEngagementQuery = useGetUserEngagementQuery;
exports.useGetRevenueAnalyticsQuery = useGetRevenueAnalyticsQuery;
exports.useGetChallengeAnalyticsQuery = useGetChallengeAnalyticsQuery;
exports.useGetGamificationAnalyticsQuery = useGetGamificationAnalyticsQuery;
exports.useGetTierDistributionQuery = useGetTierDistributionQuery;
exports.useGetActivityHeatmapQuery = useGetActivityHeatmapQuery;
exports.useGetTopRewardsQuery = useGetTopRewardsQuery;
exports.useGetTopBranchesQuery = useGetTopBranchesQuery;
exports.useGetTopEarnersQuery = useGetTopEarnersQuery;
